import { flySearchResponseData } from '../../../models/FlySearchResponseModel'
import { setInitialFilterInfo } from '../../filters'

/**
 * The following function gets invoked during resetting filters
 * moving from 1 tab to another for SBS
 * */
export function loadSavedFilterInfo({ tabId = 1 }) {
  return dispatch => {
    dispatch(
      setInitialFilterInfo(flySearchResponseData.filters[tabId], {
        isSBS: true,
        activeTabId: tabId,
        prevTab: (tabId % 2) + 1
      })
    )
  }
}

/**
 * Code Smell: Nastiest way to reset Filter values
 */

export function setTabDefaultFilters({ tabId = 1 }) {
  return (dispatch, getState) => {
    const { filters } = flySearchResponseData
    filters[tabId] = {
      sliceRefId: tabId,
      filterDefaults: getState().filterInfo.defaults,
      AIRLINES: getState().airlinesFilter,
      AIRPORTS: getState().airportsFilter,
      DATE: getState().altDatesFilter,
      DEFAULT_TAB_ITEMS: getState().filterInfo.defaults.DEFAULT_TAB_ITEMS,
      DEFAULT_TIME: getState().filterInfo.defaults.DEFAULT_TIME,
      NUM_OF_STOPS: getState().stopsFilter,
      SLICE_ARRAY: getState().filterInfo.defaults.SLICE_ARRAY,
      TIME: getState().timeFilter
    }
  }
}
